import React, { Component } from 'react'
import style from './style.module.less'
import { POSITION_MAP } from '@components/LocalMerchant/SiDa/constant'
import cls from 'classnames'

export default class extends Component {
  render() {
    const { logo_path, name, position, working_seniority, merchant_comment } =
      this.props.item || {}
    const { total_good_count } = merchant_comment || {}

    return (
      <div className={style.item}>
        <img src={logo_path} className={style.logo} />

        <div className={style.info}>
          <div className={cls(style.name, 'text-cut')}>{name}</div>
          <div className={style.position}>
            {position ? <span>{POSITION_MAP[position]}·</span> : null}
            从业{working_seniority}年
          </div>
          <div className={style.goodCount}>
            <span>好评数</span>
            <span className={style.number}>{total_good_count}</span>
          </div>
        </div>
      </div>
    )
  }
}
